import React from 'react';

const Graph = _ => (
	<main id="graph"></main>
);

export default Graph;
